const mixinFormulario = {
    data(){
        return {
            error: '',
            valido : false,
            cargandoFormulario : false,
            email : '',
            password : '',
            reglasNombre :[
                (nombre) => nombre.length>0 || 'Debe ingresar un nombre valido',
                (nombre) => nombre.length<=25 || 'Debe ingresar menos de 25 caracteres'
            ],
            reglasEmail : null,
            reglasPassword : [
                (password) => password.length>8 || 'Debe ingresar una contraseña mayor de 8 caracteres',
            ],
            reglasRepetirPassword : [
                (repetirPassword) => this.password === repetirPassword || 'Las contraseñas deben coincidir'
            ]
        }
    },
    methods:{
        validarEmail() {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(this.email).toLowerCase());
        },
        checarEmail(){
            console.log('checando')
            /*
            if(this.validarEmail()){
                this.reglasEmail = true
            }else{
                this.reglasEmail = false
            }*/
        }
    }
}

export {
    mixinFormulario
}


// WEBPACK FOOTER //
// ./src/mixins/mixins.js